import { createSlice } from '@reduxjs/toolkit';
import { postOptions } from '../../enums/enums';

const reportsSlice = createSlice({
  name: 'reports',
  initialState: {
    gamers: {
      payload: {
        pageNo: 1,
        pageSize: postOptions[0].value,
        pageCount: 1
      },
      list: [],
      total: {}
    },
    bonuses: { payload: {}, info: {}, total: {} },
    refcode: { payload: {}, info: [], total: {} }
  },
  reducers: {
    setGamersPayload: (state, action) => {
      state.gamers.payload = action.payload;
    },
    setGamersList: (state, action) => {
      state.gamers.list = action.payload;
    },
    setGamersTotal: (state, action) => {
      state.gamers.total = action.payload;
    },
    setBonusesPayload(state, action) {
      state.bonuses.payload = action.payload;
    },
    setBonusesData(state, action) {
      state.bonuses.info = action.payload;
    },
    setBonusesTotal(state, action) {
      state.bonuses.total = action.payload;
    },
    setRefcodePayload(state, action) {
      state.refcode.payload = action.payload;
    },
    setRefcodeInfo(state, action) {
      state.refcode.info = action.payload;
    },
    setRefcodeTotal(state, action) {
      state.refcode.total = action.payload;
    }
  }
});

export default reportsSlice.reducer;

export const {
  setGamersPayload,
  setGamersList,
  setGamersTotal,
  setBonusesPayload,
  setBonusesData,
  setBonusesTotal,
  setRefcodePayload,
  setRefcodeTotal,
  setRefcodeInfo
} = reportsSlice.actions;
